<template>
  <div
    v-if="isOffline"
    class="connectivity-banner"
    role="status"
    aria-live="polite"
  >
    <i class="bi bi-wifi-off" aria-hidden="true"></i>
    <span class="connectivity-banner__text">{{ message }}</span>
    <button type="button" class="connectivity-banner__retry" @click="retry">
      Try again
    </button>
  </div>
</template>

<script setup>
import { useConnectivity } from '@/utils/connectivity';

const { isOffline, message, retry } = useConnectivity();
</script>
